import { Banner } from '../Components';

const ConstructionUpdates = () => {
  const StageSection = ({ title, updates = [] }) => (
    <div className="p-6 rounded-lg mb-8 h-full w-full">
      <h3 className="text-2xl font-tobias font-semibold text-gableGreen mb-6 border-b border-gray-200">{title}</h3>
      <div className="mb-4">
        <div className="w-full h-[1px] bg-gray-500 rounded-full"></div>
      </div>
      {updates.length > 0 ? (
        <ul className="list-disc pl-6 space-y-3 text-gray-700">
          {updates.map((update, index) => (
            <li key={index} className="leading-relaxed">
              {update}
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-gray-600 italic">Completed</p>
      )}
    </div>
  );

  const constructionStages = [
    {
      title: "Stage 1",
      updates: [] // Completed
    },
    {
      title: "Stage 2",
      updates: [] // Completed
    },
    {
      title: "Stage 3",
      updates: [] // Completed
    },
    {
      title: "Stage 3/4",
      updates: [] // Completed
    },
    {
      title: "Stage 4",
      updates: [] // Completed
    },
    {
      title: "Stage 5",
      updates: [] // Completed
    },
    {
      title: "Stage 6",
      updates: [] // Completed
    },
    {
      title: "Stage 10/11",
      updates: [
        "Bulk earthworks continue, with cut-to-fill works and export advancing",
        "Sewer infrastructure has progressed, including excavation, installation and backfilling",
        "Stormwater installation is underway",
        "Retaining wall works have progressed, including wall trimming to Stage 10A",
        "Detention tank construction and roofwater connections remain ongoing",
        "Additional environmental controls have been installed in preparation for forecast wet weather, with dust mitigation measures maintained across site"
      ]
    }
  ];

  return (
    <>
      <Banner
        title={'Construction Updates'}
        bgImage='bg-building-resources-banner'
      />

      <div className="container mx-auto py-16 px-4 md:px-8">
        <div>
          <div className="mb-10 text-center">
            <h2 className="text-4xl font-tobias font-bold mb-4 text-gableGreen">Banyan Hill Construction Updates</h2>
            <p className="max-w-2xl mx-auto text-gray-600">
              Stay up to date with the latest construction progress across our stages.
              If you have any queries, please contact the Banyan Hill sales team on <a href="tel:+611300326197" className="text-blue-600 hover:underline">1300 326 197</a>.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {constructionStages.map((stage, index) => (
              <div key={index} className="h-full flex">
                <StageSection
                  title={stage.title}
                  updates={stage.updates}
                />
              </div>
            ))}
          </div>

          <div className="mt-10 text-center">
            <p className="text-sm text-gray-500">
              © Banyan Hill {new Date().getFullYear()} - Construction Updates
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConstructionUpdates;
